import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import { confirmDownloadable, filterAttachmentViewing } from '../helper';
import Events from '../hooks/events';

const AttachmentViewTools = ({
  attachment,
  category,
  code,
  disabled,
}) => {
  const intl = useIntl();
  const showDownloadableConfirmation = Events.useShowDownloadableConfirmationDialog(category, { code });
  const updateMetadata = Events.useUpdateDatasetAttachmentMetadata({ category, code });
  const { metadata, id: attachmentId } = attachment;

  const onAttachmentViewingChange = (viewing) => {
    if (confirmDownloadable(attachment, viewing)) {
      showDownloadableConfirmation({ attachmentId });
    } else { updateMetadata({ attachmentId, metadata: { viewing } }); }
  };

  return (
    <>
      <Dropdown.Header content={intl.formatMessage({ id: 'dataset.attachments.viewing.header' })} />
      {filterAttachmentViewing(metadata).map(({ className, name, icon }) => (
        <Dropdown.Item
          as="a"
          className={className}
          disabled={disabled || metadata.viewing === name}
          icon={icon}
          key={`dataset_attachments_viewing_${name}`}
          onClick={() => onAttachmentViewingChange(name)}
          text={intl.formatMessage({ id: `dataset.attachments.viewing.${name}` })}
        />
      ))}
    </>
  );
};

export default AttachmentViewTools;
